import errorCode from './localizedErrorCodes';
import labelTexts from './localizedLabelTexts';

export default {
  ...errorCode,
  ...labelTexts,
  ERROR_PLACING_ORDER: {
    en: 'There was an error placing the order.',
    zh: ''
  }
};
